export const responseAmazonAttributionBrands = {
  data: []
};